<template>
    <div class="module-relation">
        <v-layout align-center justify-left>
            <div v-if="$userData.spouse" class="icon-spouse">
                <div class="assets">
                    <img :src="image" class="front face" />
                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_backface_spouse.png" class="back face" />
                </div>
            </div>
            <div v-if="$userData.hasBaby" class="icon-baby">
                <div class="assets">
                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_baby.png" class="front face" />
                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_backface_baby.png" class="back face" />
                </div>
            </div>
        </v-layout>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                images: {
                    '20-15': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_15m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_15f.png',
                    },
                    '30-8': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_23m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_23f.png',
                    },
                    '30-16': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_31m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_31f.png',
                    },
                    '40-3': {
                        'm': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_35m.png',
                        'f': 'https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_spouse_35f.png',
                    },
                },
            }
        },

        computed: {
            image() {
                if (!this.$userData.spouse) return
                return this.images[this.$userData.spouse][this.$userData.gender.toLowerCase()]
            },
            baby() {
                return this.$userData.hasBaby
            }
        },

        watch: {
            image(val, oldVal) {
                if (val) {
                    setTimeout(_ => {
                        this.$playAudio(11)
                    }, 300)
                    setTimeout(_ => {
                        $('.icon-spouse').addClass('drop')
                        $('.icon-spouse .assets').addClass('flip')

                        setTimeout(_ => {
                            $('.icon-spouse').removeClass('drop')
                            $('.icon-spouse .assets').removeClass('flip')
                        },2000)
                    })
                }
            },
            baby(val) {
                setTimeout(_ => {
                    this.$playAudio(11)
                }, 300)
                setTimeout(_ => {
                    $('.icon-baby').addClass('drop')
                    $('.icon-baby .assets').addClass('flip')

                    setTimeout(_ => {
                        $('.icon-baby').removeClass('drop')
                        $('.icon-baby .assets').removeClass('flip')
                    },2000)
                })
            }
        },
        mounted() {

            // $('.icon-spouse').click(_ => {
            //     $('.icon-spouse').addClass('drop')
            //     $('.icon-spouse .assets').addClass('flip')
            //
            //     setTimeout(_ => {
            //         $('.icon-spouse').removeClass('drop')
            //         $('.icon-spouse .assets').removeClass('flip')
            //     },1200)
            // })
        },
        methods: {

        }
    }
</script>

<style lang="scss" scoped>
    .module-relation{
        width: 103.3px;
        height: 46.1px;
        margin-top: 9.2px;
        margin-left: 40.2px;
        display: inline-block;
        position: relative;

        .icon-spouse, .icon-baby {
            width: 47px;
            height: 47px;

            .assets {
                position: relative;
                width: 100%;
                height: 100%;
                transform-style: preserve-3d;
            }

            .face {
                position: absolute;
                -webkit-backface-visibility: hidden;
                backface-visibility: hidden;
            }
            .front {
            }

            .back {
                transform: rotateY( 180deg );
            }
        }

        .icon-baby { position: absolute; right: 0}

        .drop {
            -webkit-animation: bounce-top 1s both;
            animation: bounce-top 1s both;
        }
        .flip {
            -webkit-animation: flip-vertical-right 0.4s linear 3 forwards;
            animation: flip-vertical-right 0.4s linear 3 forwards;
        }

    }


</style>

<style>


    /**
     * ----------------------------------------
     * animation bounce-top
     * ----------------------------------------
     */
    @-webkit-keyframes bounce-top {
        0% {
            -webkit-transform: translateY(-60px);
            transform: translateY(-60px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 1;

        }
        24% {
            opacity: 1;
        }
        40% {
            -webkit-transform: translateY(-24px);
            transform: translateY(-24px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        65% {
            -webkit-transform: translateY(-12px);
            transform: translateY(-12px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        82% {
            -webkit-transform: translateY(-6px);
            transform: translateY(-6px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        93% {
            -webkit-transform: translateY(-4px);
            transform: translateY(-4px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        25%,
        55%,
        75%,
        87% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        100% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
        }
    }
    @keyframes bounce-top {
        0% {
            -webkit-transform: translateY(-60px);
            transform: translateY(-60px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
            opacity: 1;

        }
        24% {
            opacity: 1;
        }
        40% {
            -webkit-transform: translateY(-24px);
            transform: translateY(-24px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        65% {
            -webkit-transform: translateY(-12px);
            transform: translateY(-12px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        82% {
            -webkit-transform: translateY(-6px);
            transform: translateY(-6px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        93% {
            -webkit-transform: translateY(-4px);
            transform: translateY(-4px);
            -webkit-animation-timing-function: ease-in;
            animation-timing-function: ease-in;
        }
        25%,
        55%,
        75%,
        87% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
        }
        100% {
            -webkit-transform: translateY(0px);
            transform: translateY(0px);
            -webkit-animation-timing-function: ease-out;
            animation-timing-function: ease-out;
            opacity: 1;
        }
    }

    /**
 * ----------------------------------------
 * animation flip-vertical-right
 * ----------------------------------------
 */
    @-webkit-keyframes flip-vertical-right {
        0% {
            -webkit-transform: rotateY(360deg);
            transform: rotateY(360deg);
        }
        /*50% {*/
        /*    -webkit-transform: rotateY(180deg);*/
        /*    transform: rotateY(180deg);*/
        /*}*/
        100% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
        }
    }
    @keyframes flip-vertical-right {
        0% {
            -webkit-transform: rotateY(360deg);
            transform: rotateY(360deg);
        }
        /*50% {*/
        /*    -webkit-transform: rotateY(180deg);*/
        /*    transform: rotateY(180deg);*/
        /*}*/
        100% {
            -webkit-transform: rotateY(0);
            transform: rotateY(0);
        }
    }
</style>
